const state = {
  themes: []
}

const mutations = {
  initTheme(state) {
    state.themes = [
      {
        theme: {
          dark: {
            primary: '#212121',
            secondary: '#FBC233',
            accent: '#00adb5'
          },
          light: {
            primary: '#0D47A1',
            secondary: '#0288D1',
            accent: '#000000'
          }
        }
      },
      {
        theme: {
          dark: {
            primary: '#212121',
            secondary: '#409BFF',
            accent: '#f638dc'
          },
          light: {
            primary: '#C63968',
            secondary: '#FF9800',
            accent: '#631C34'
          }
        }
      },
      {
        theme: {
          dark: {
            primary: '#212121',
            secondary: '#CAE00F',
            accent: '#ff2e63'
          },
          light: {
            primary: '#48409F',
            secondary: '#FF7366',
            accent: '#78BCC4'
          }
        }
      },
      {
        theme: {
          dark: {
            primary: '#212121',
            secondary: '#FF375F',
            accent: '#FBC233'
          },
          light: {
            primary: '#c9d6df',
            secondary: '#52616b',
            accent: '#1e2022'
          }
        }
      },
      {
        theme: {
          dark: {
            primary: '#212121',
            secondary: '#8CE9DC',
            accent: '#ff2e63'
          },
          light: {
            primary: '#00b8a9',
            secondary: '#757575',
            accent: '#f6416c'
          }
        }
      },
      {
        theme: {
          dark: {
            primary: '#212121',
            secondary: '#e5e5e5',
            accent: '#d72323'
          },
          light: {
            primary: '#757575',
            secondary: '#d72323',
            accent: '#c9d6df'
          }
        }
      }
    ]
  }
}

const actions = {
  initHoneyTheme({ commit }) {
    commit('initTheme')
  }
}

export default {
  state,
  actions,
  mutations
}
